<template>
  <li>
    <router-link :to="{ name: 'system.notifications.show', params: { id: notification.id } }">
      <div class="row">
        <div class="col-xs-9 col-md-10 ">
          <h3>{{ notification.title }}</h3>
          <p>{{ notification.content }}</p>
          <br/>
          <p><i class="fa fa-calendar fa-fw"></i> Sent: {{ notification.created_at | timeTimezone($user.timezone) }} on
            {{ notification.created_at | dateTimezone($user.timezone, $user.date_format_preference) }}</p>
          <p><i class="fa fa-user fa-fw"></i> Sent By: {{ notification.creator }}</p>
        </div>
        <div class="col-xs-3 col-md-2 text-right">
          <h2 :class="percentageColour">{{ talentResponseRate }}</h2>
          <p>Responded</p>
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
export default {
  props: ['notification', 'index'],

  computed: {
    percentageColour () {
      switch (true) {
        case this.notification.response_percentage < 20:
          return 'text-danger'
        case this.notification.response_percentage < 70:
          return 'text-warning'
        default:
          return 'text-success'
      }
    },

    talentResponseRate () {
      return `${this.notification.responded_users}/${this.notification.sent_to}`
    }
  }
}
</script>
